import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize'
})

export class CapitalizePipe implements PipeTransform {

  transform(value:any, words:boolean) {
    let string: String = value;
    string = string.toLocaleLowerCase();

    if(value) {
      if(words) {
        return string.replace(/\b\w/g, first => first.toLocaleUpperCase());
      }
      else {
        return string.charAt(0).toUpperCase() + string.slice(1);
      }
    }

    return value;
  }
}